export default "__VITE_ASSET__CURnRm50__"